<div class="credits-bar">
  @let ready = creditsReady();
  <div class="credits-left">
    <div id="ai-credits-bars" class="signal-bars" #signalBarsEl [ngClass]="ready ? credits.levelClass() : 'level-loading'">
      <span class="bar bar-1" #bar1El [class.active]="credits.activeBars().bar1"></span>
      <span class="bar bar-2" #bar2El [class.active]="credits.activeBars().bar2"></span>
      <span class="bar bar-3" #bar3El [class.active]="credits.activeBars().bar3"></span>
      <span class="bar bar-4" #bar4El [class.active]="credits.activeBars().bar4"></span>
    </div>
    <div class="credits-info">
      <span id="ai-credits-number" class="credits-number" #creditsNumberEl [ngClass]="ready ? credits.levelClass() : 'level-loading'">
        @if (ready) {
          kr <span #creditsNumberText></span>
        } @else {
          kr &hellip;
        }
      </span>
      <span class="credits-label">{{ 'aiReport.lbl_credits_remaining' | translate }}</span>
    </div>
  </div>

  <div class="credits-right">
    @if (ready && credits.isLow()) {
      <span role="status" id="ai-credits-badge-low" class="badge badge-low"><span aria-hidden="true">⚠</span> {{ 'aiReport.lbl_credits_low' | translate }}</span>
    }
    @if (credits.balanceLoaded() && credits.isEmpty()) {
      <span role="status" id="ai-credits-badge-empty" class="badge badge-empty"><span aria-hidden="true">⊘</span> {{ 'aiReport.lbl_credits_empty' | translate }}</span>
    }
    <button id="ai-credits-topup-open" class="btn-topup" type="button" (click)="openModal()">
      {{ 'aiReport.lbl_credits_topup' | translate }}
    </button>
  </div>
</div>

<dialog id="ai-topup-dialog" #topupDialog class="topup-dialog" (click)="onDialogClick($event)" (keydown.escape)="closeModal()">
  <div class="dialog-inner" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    @switch (screen()) {
      @case ('amount') {
        <h3 class="modal-title">{{ 'aiReport.lbl_credits_topup_title' | translate }}</h3>
        <label class="amount-label" for="topup-amount">{{ 'aiReport.lbl_credits_topup_amount_label' | translate }}</label>
        <input
          id="topup-amount"
          class="amount-input"
          type="number"
          [placeholder]="'aiReport.lbl_credits_topup_amount_placeholder' | translate"
          [value]="amountNok() ?? ''"
          (input)="onAmountInput($event)"
        />
        @if (hint() !== null) {
          <p id="ai-topup-hint" class="hint">{{ 'aiReport.lbl_credits_topup_hint' | translate: { count: hint() } }}</p>
        } @else if (exampleHint(); as example) {
          <p class="hint hint-example">{{ 'aiReport.lbl_credits_topup_hint_example' | translate: { amount: example.amount, count: example.count } }}</p>
        }
        @if (amountNok() !== null && !isValidAmount() && config()) {
          <p id="ai-topup-validation" class="validation-error">
            {{ 'aiReport.lbl_credits_topup_validation' | translate: { min: config()!.minTopupNok, max: config()!.maxTopupNok } }}
          </p>
        }
        <button id="ai-topup-pay" class="btn-pay" type="button" [disabled]="!isValidAmount()" (click)="payWithVipps()">
          {{ 'aiReport.lbl_credits_topup_pay_button' | translate }}
        </button>
      }
      @case ('processing') {
        <h3 class="modal-title">{{ 'aiReport.lbl_credits_topup_processing_title' | translate }}</h3>
        <div class="spinner" role="status" [attr.aria-label]="'aiReport.lbl_credits_topup_processing_aria' | translate"></div>
        <p class="dialog-body">{{ 'aiReport.lbl_credits_topup_processing_body' | translate }}</p>
      }
      @case ('success') {
        <h3 class="modal-title">{{ 'aiReport.lbl_credits_topup_success_title' | translate }}</h3>
        <p id="ai-topup-success" class="dialog-body success-balance">
          {{ 'aiReport.lbl_credits_topup_success_body' | translate: { balance: formattedDisplayBalance() } }}
        </p>
        <button id="ai-topup-close" class="btn-got-it" type="button" (click)="closeModal()">
          {{ 'aiReport.lbl_credits_topup_continue' | translate }}
        </button>
      }
      @case ('error') {
        <h3 class="modal-title">{{ 'aiReport.lbl_credits_topup_title' | translate }}</h3>
        <p id="ai-topup-error" class="dialog-body error-message">{{ errorMessage() }}</p>
        <button id="ai-topup-retry" class="btn-pay" type="button" (click)="tryAgain()">
          {{ 'aiReport.lbl_credits_topup_try_again' | translate }}
        </button>
      }
    }
    <p class="disclaimer">{{ 'aiReport.lbl_credits_disclaimer' | translate }}</p>
  </div>
</dialog>
